const initialPoiSearchRadiusPresetsData = [
  { id: 1, label: '20 km', km: 20, sortOrder: 10, createdAt: Date.now(), updatedAt: null },
  { id: 2, label: '50 km', km: 50, sortOrder: 20, createdAt: Date.now(), updatedAt: null },
  { id: 3, label: '100 km', km: 100, sortOrder: 30, createdAt: Date.now(), updatedAt: null },
  { id: 4, label: '250 km', km: 250, sortOrder: 40, createdAt: Date.now(), updatedAt: null },
  { id: 5, label: '500 km', km: 500, sortOrder: 50, createdAt: Date.now(), updatedAt: null },
  { id: 6, label: '1000 km', km: 1000, sortOrder: 60, createdAt: Date.now(), updatedAt: null },
  { id: 7, label: 'Global', km: null, sortOrder: 70, createdAt: Date.now(), updatedAt: null }
];

export const DEFAULT_POI_SEARCH_RADIUS_PRESET_ID = 2;

export default initialPoiSearchRadiusPresetsData;
